import { AxiosResponse } from 'axios';
import { CommonFilterCriteria, PageRequest } from '../types/CommonTypes';
import { WebRotateType } from '../types/cmsWebRotate.type';
import { axios, get, post, put } from './cmsAxios';
import { API_ADMIN_INTEG_WEB_ROTATE, API_ADMIN_WEB_ROTATE } from '../utils/urls';
import { PaginationResponseType } from '../types/CommonTypes';

const url = API_ADMIN_WEB_ROTATE;
const urlInteg = API_ADMIN_INTEG_WEB_ROTATE;
const GET_BY_CODE = 'get-by-code';

export const getById = (id: number): Promise<AxiosResponse<WebRotateType>> => get(`${url}/${id}`);

export const getByCode = (code: string): Promise<AxiosResponse<WebRotateType>> => {
  return get([urlInteg, GET_BY_CODE, code].join('/'));
};

export const filter = (
  params: CommonFilterCriteria & PageRequest
): Promise<AxiosResponse<PaginationResponseType<WebRotateType>>> =>
  get(urlInteg, { params: { ...params, type: 'VIRTUAL_TOUR' } });

export const update = (id: number, request: WebRotateType): Promise<AxiosResponse<WebRotateType>> =>
  put(`${url}/${id}`, request);

export const create = (request: WebRotateType): Promise<AxiosResponse<WebRotateType>> =>
  post(`${url}`, request);

export const deleteById = (id: number): Promise<AxiosResponse<boolean>> =>
  axios.delete(`${url}/${id}`);

export const uploadWebRotate = async (formData: any): Promise<any> => {
  return post(`${url}/upload-layout`, formData);
};

export const publish = (request) => post(`${url}/published`, request);
